// extracted by mini-css-extract-plugin
module.exports = {"dialogOverlay":"base-modal-dialog_dialogOverlay__Yf4bt","dialogTitle":"base-modal-dialog_dialogTitle__GKebI","dialogBody":"base-modal-dialog_dialogBody__HxidW"};